import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Row, Col, Tabs, Tab, Form, Button, Card, CardBody, Modal, Stack } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import DataTableLayout from "layouts/DatatableLayout";
import DownloadExcel from "utils/DownloadExcel";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { nanoid } from "nanoid";
import moment from "moment";
import "moment/locale/th";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { defaultOption } from "constants/ui/options";
import { ModalAllder } from "layouts/ModalAllder";
import { getPrefixName, getInfoAdminSystem, formatNumber } from "utils/HelperFunction";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Avatar from "@mui/material/Avatar";
import InfoIcon from "@mui/icons-material/Info";
import { getAllMstTypeProduct, clearGetAllMstTypeProduct } from "../../redux/handlers/setting/getAllMstTypeProduct.handler";
import { createMstTypeProduct, clearCreateMstTypeProduct } from "../../redux/handlers/setting/createMstTypeProduct.handler";
import { updateMstTypeProduct, clearUpdateMstTypeProduct } from "../../redux/handlers/setting/updateMstTypeProduct.handler";
import { deleteMstTypeProduct, clearDeleteMstTypeProduct } from "../../redux/handlers/setting/deleteMstTypeProduct.handler";
import { getAllMstCateProduct, clearGetAllMstCateProduct } from "../../redux/handlers/setting/getAllMstCateProduct.handler";
import { createMstCateProduct, clearCreateMstCateProduct } from "../../redux/handlers/setting/createMstCateProduct.handler";
import { updateMstCateProduct, clearUpdateMstCateProduct } from "../../redux/handlers/setting/updateMstCateProduct.handler";
import { deleteMstCateProduct, clearDeleteMstCateProduct } from "../../redux/handlers/setting/deleteMstCateProduct.handler";
import { getAllMstSubCateProduct, clearGetAllMstSubCateProduct } from "../../redux/handlers/setting/getAllMstSubCateProduct.handler";
import { createMstSubCateProduct, clearCreateMstSubCateProduct } from "../../redux/handlers/setting/createMstSubCateProduct.handler";
import { updateMstSubCateProduct, clearUpdateMstSubCateProduct } from "../../redux/handlers/setting/updateMstSubCateProduct.handler";
import { deleteMstSubCateProduct, clearDeleteMstSubCateProduct } from "../../redux/handlers/setting/deleteMstSubCateProduct.handler";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import DataSyncControl from "layouts/DataSyncControl";
import { syncProductType } from "../../redux/handlers/syncdata/syncProductType.handler";
import { syncProductCategory } from "../../redux/handlers/syncdata/syncProductCategory.handler";
import { syncProductSubCategory } from "../../redux/handlers/syncdata/syncProductSubCategory.handler";
export function SettingsMaster() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState("ประเภทสินค้า"), 2), nameTab = _useState[0], setNameTab = _useState[1];
    var _useState1 = _sliced_to_array(useState(1), 2), noTab = _useState1[0], setNoTab = _useState1[1];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-2 mb-4",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item ",
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "/setting/master",
                                className: "tc-7  text-decoration-none",
                                children: "ตั้งค่า"
                            })
                        }),
                        /*#__PURE__*/ _jsxs("li", {
                            className: "breadcrumb-item active tc-1 ",
                            "aria-current": "page",
                            children: [
                                " ",
                                "Master",
                                " "
                            ]
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item active tc-1 ",
                            "aria-current": "page",
                            children: " " + nameTab + " "
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-4",
                children: /*#__PURE__*/ _jsx("h3", {
                    className: "h3",
                    children: nameTab
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-4",
                children: /*#__PURE__*/ _jsx(DocTabs, {
                    noTab: noTab,
                    setNoTab: setNoTab,
                    nameTab: nameTab,
                    setNameTab: setNameTab
                })
            })
        ]
    });
}
function DocTabs(_param) {
    var noTab = _param.noTab, setNoTab = _param.setNoTab, props = _object_without_properties(_param, [
        "noTab",
        "setNoTab"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), reloadType = _useState[0], setReloadType = _useState[1];
    var _useState1 = _sliced_to_array(useState("product_type"), 2), activeKeyTab = _useState1[0], setActiveKeyTab = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), optionPdType = _useState2[0], setOptionPdType = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), optionPdCate = _useState3[0], setOptionPdCate = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), optionPdSubCate = _useState4[0], setOptionPdSubCate = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), dataPdType = _useState5[0], setDataPdType = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), dataPdCate = _useState6[0], setDataPdCate = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), dataPdSubCate = _useState7[0], setDataPdSubCate = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), idPdType = _useState8[0], setIdPdType = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), idPdCate = _useState9[0], setIdPdCate = _useState9[1];
    var getAllMstTypeProductReducer = useAppSelector(function(state) {
        return state.getAllMstTypeProductReducer;
    });
    var getAllMstCateProductReducer = useAppSelector(function(state) {
        return state.getAllMstCateProductReducer;
    });
    var getAllMstSubCateProductReducer = useAppSelector(function(state) {
        return state.getAllMstSubCateProductReducer;
    });
    var getDataMst = function() {
        dispatch(getAllMstTypeProduct({
            status: null
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getAllMstCateProduct({
            status: null
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getAllMstSubCateProduct({
            status: null
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        setIsLoading(getAllMstTypeProductReducer.isFetching || getAllMstCateProductReducer.isFetching || getAllMstSubCateProductReducer.isFetching);
        if (getAllMstTypeProductReducer.data && !getAllMstTypeProductReducer.isError) {
            var rawData = getAllMstTypeProductReducer.data.data;
            var withNo = rawData.map(function(item, index) {
                return _object_spread_props(_object_spread({}, item), {
                    set_producttype_no: index + 1,
                    set_producttype_cate_amount: item._count && item._count.set_productcategory && item._count.set_productcategory >= 0 ? formatNumber(item._count.set_productcategory, 0) : 0,
                    set_producttype_subcate_amount: item._count && item._count.set_productcategorysub && item._count.set_productcategorysub >= 0 ? formatNumber(item._count.set_productcategorysub, 0) : 0
                });
            });
            setDataPdType(withNo);
            setOptionPdType(rawData.map(function(item2, index) {
                return {
                    label: item2.set_producttype_name,
                    value: item2.set_producttype_id
                };
            }));
        }
        if (getAllMstCateProductReducer.data && !getAllMstCateProductReducer.isError) {
            var rawData2 = getAllMstCateProductReducer.data.data;
            var withNo2 = rawData2.map(function(item, index) {
                return _object_spread_props(_object_spread({}, item), {
                    set_productcategory_no: index + 1,
                    set_productcategory_subcate_amount: item._count && item._count.set_productcategorysub && item._count.set_productcategorysub >= 0 ? formatNumber(item._count.set_productcategorysub, 0) : 0
                });
            });
            setDataPdCate(withNo2);
            setOptionPdCate(rawData2.map(function(item2, index) {
                return {
                    label: item2.set_productcategory_name,
                    value: item2.set_productcategory_id
                };
            }));
        }
        if (getAllMstSubCateProductReducer.data && !getAllMstSubCateProductReducer.isError) {
            var rawData3 = getAllMstSubCateProductReducer.data.data;
            var withNo3 = rawData3.map(function(item, index) {
                return _object_spread_props(_object_spread({}, item), {
                    set_productcategorysub_no: index + 1
                });
            });
            setDataPdSubCate(withNo3);
        }
    }, [
        getAllMstTypeProductReducer,
        getAllMstCateProductReducer,
        getAllMstSubCateProductReducer
    ]);
    useEffect(function() {
        getDataMst();
    }, []);
    useEffect(function() {
        if (noTab && noTab > 0) {
            if (noTab == 3) {
                setActiveKeyTab("product_sub_cate");
            } else if (noTab == 2) {
                setActiveKeyTab("product_cate");
            } else {
                setActiveKeyTab("product_type");
            }
        } else {
            setActiveKeyTab("product_type");
        }
        if (reloadType) {
            getDataMst();
            setReloadType(false);
        }
    }, [
        noTab,
        reloadType
    ]);
    var firstRender = useRef(true);
    var prevIdPdType = useRef(idPdType);
    var prevIdPdCate = useRef(idPdCate);
    useEffect(function() {
        if (firstRender.current) {
            firstRender.current = false;
            return; // 👈 ข้ามตอน mount ครั้งแรก
        }
        // เงื่อนไขเมื่อเปลี่ยนจริง
        if (idPdType !== prevIdPdType.current && dataPdType && dataPdType.length > 0) {
            console.log("idPdType : ", idPdType);
            console.log("dataPdType : ", dataPdType);
        }
        if (idPdCate !== prevIdPdCate.current && dataPdCate && dataPdCate.length > 0) {
            console.log("idPdCate : ", idPdCate);
            console.log("dataPdCate : ", dataPdCate);
        }
        prevIdPdType.current = idPdType;
        prevIdPdCate.current = idPdCate;
    }, [
        idPdType,
        idPdCate
    ]);
    // ตัวอย่างข้อมูล tab พร้อมเงื่อนไข
    var allTabs = [
        {
            eventKey: "product_type",
            title: "ประเภทสินค้า",
            visible: function() {
                return true;
            },
            content: /*#__PURE__*/ _jsx(ProductTypeData, {
                setNoTab: setNoTab,
                idPdType: idPdType,
                setIdPdType: setIdPdType,
                dataPdType: dataPdType,
                setDataPdType: setDataPdType,
                reDataMst: function() {
                    return setReloadType(true);
                }
            })
        },
        {
            eventKey: "product_cate",
            title: "หมวดหมู่หลัก",
            visible: function() {
                return true;
            },
            content: /*#__PURE__*/ _jsx(ProductCateData, {
                optionPdType: optionPdType,
                setNoTab: setNoTab,
                dataPdCate: dataPdCate,
                setDataPdCate: setDataPdCate,
                reDataMst: function() {
                    return setReloadType(true);
                }
            })
        },
        {
            eventKey: "product_sub_cate",
            title: "หมวดหมู่ย่อย",
            visible: function() {
                return true;
            },
            content: /*#__PURE__*/ _jsx(ProductSubCateData, {
                optionPdType: optionPdType,
                optionPdCate: optionPdCate,
                setNoTab: setNoTab,
                dataPdSubCate: dataPdSubCate,
                setDataPdSubCate: setDataPdSubCate,
                dataPdCate: dataPdCate,
                reDataMst: function() {
                    return setReloadType(true);
                }
            })
        }
    ];
    var visibleTabs = allTabs.filter(function(tab) {
        return tab.visible();
    });
    return /*#__PURE__*/ _jsx(Tabs, {
        defaultActiveKey: activeKeyTab,
        id: "doc-tab-detail-com",
        className: "mb-3 pills-st-1",
        variant: "pills",
        onSelect: function(k) {
            if (k && k != "" && k == "product_sub_cate") {
                setNoTab(3);
                props.setNameTab("หมวดหมู่ย่อย");
            } else if (k && k != "" && k == "product_cate") {
                setNoTab(2);
                props.setNameTab("หมวดหมู่หลัก");
            } else {
                setNoTab(1);
                props.setNameTab("ประเภทสินค้า");
            }
        },
        children: visibleTabs.map(function(tab) {
            return /*#__PURE__*/ _jsx(Tab, {
                eventKey: tab.eventKey,
                title: tab.title,
                children: tab.content
            }, tab.eventKey);
        })
    });
}
function ProductTypeData(_param) {
    var dataPdType = _param.dataPdType, setDataPdType = _param.setDataPdType, props = _object_without_properties(_param, [
        "dataPdType",
        "setDataPdType"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), excelData = _useState[0], setExcelData = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), filteredItems = _useState1[0], setFilteredItems = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), filterText = _useState2[0], setFilterText = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), reloadType = _useState3[0], setReloadType = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), textsuccess = _useState5[0], setTextsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), modelText = _useState6[0], setmodelText = _useState6[1];
    var handleViewCate = function() {
        var idPdType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        if (idPdType && idPdType != "" && idPdType != null && idPdType >= 0) {
            props.setIdPdType(parseInt(idPdType, 10));
        } else {
            props.setIdPdType(0);
        }
        props.setNoTab(2);
    };
    var handleViewSubCate = function() {
        var idPdType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        if (idPdType && idPdType != "" && idPdType != null && idPdType >= 0) {
            props.setIdPdType(parseInt(idPdType, 10));
        } else {
            props.setIdPdType(0);
        }
        props.setNoTab(3);
    };
    var _useState7 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 350,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState7[0], setModal = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState8[0], setModalDel = _useState8[1];
    var columns = [
        {
            name: "ลำดับที่",
            selector: function(row) {
                return row.set_producttype_no;
            },
            center: "true",
            width: "80px"
        },
        {
            name: "รหัสประเภทสินค้า",
            selector: function(row) {
                var _row_set_producttype_code;
                return (_row_set_producttype_code = row.set_producttype_code) !== null && _row_set_producttype_code !== void 0 ? _row_set_producttype_code : "-";
            },
            center: "true",
            width: "150px"
        },
        {
            name: "ชื่อประเภทสินค้า (TH)",
            selector: function(row) {
                var _row_set_producttype_name;
                return (_row_set_producttype_name = row.set_producttype_name) !== null && _row_set_producttype_name !== void 0 ? _row_set_producttype_name : "-";
            }
        },
        {
            name: "ชื่อประเภทสินค้า (EN)",
            selector: function(row) {
                var _row_set_producttype_nameen;
                return (_row_set_producttype_nameen = row.set_producttype_nameen) !== null && _row_set_producttype_nameen !== void 0 ? _row_set_producttype_nameen : "-";
            }
        },
        {
            name: "ชื่อประเภทสินค้า (LAO)",
            selector: function(row) {
                var _row_set_producttype_namela;
                return (_row_set_producttype_namela = row.set_producttype_namela) !== null && _row_set_producttype_namela !== void 0 ? _row_set_producttype_namela : "-";
            }
        },
        {
            name: "จำนวนหมวดหมู่หลัก",
            selector: function(row) {
                return row.set_producttype_cate_amount ? parseInt(row.set_producttype_cate_amount, 10) : 0;
            },
            center: "true",
            width: "200px"
        },
        {
            name: "จำนวนหมวดหมู่ย่อย",
            selector: function(row) {
                return row.set_producttype_subcate_amount ? parseInt(row.set_producttype_subcate_amount, 10) : 0;
            },
            center: "true",
            width: "200px"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.set_producttype_status;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return row.set_producttype_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "เปิดใช้งาน"
                }) || row.set_producttype_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ปิดใช้งาน"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.set_producttype_id;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center gap-1",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "editType",
                                        data: {
                                            id: row.set_producttype_id,
                                            name: row.set_producttype_name,
                                            nameEn: row.set_producttype_nameen,
                                            nameLao: row.set_producttype_namela,
                                            status: row.set_producttype_status
                                        }
                                    });
                                });
                                setmodelText("แก้ไขประเภทสินค้า");
                            },
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                style: {
                                    color: "#797A7A",
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#E9E9E9",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalDel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "deleteType",
                                        data: {
                                            id: row.set_producttype_id,
                                            name: row.set_producttype_name
                                        }
                                    });
                                });
                                setmodelText("ยืนยันลบประเภทสินค้า");
                            },
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                style: {
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "rgb(255, 227, 227)",
                                    color: "#FF0000",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(DataSyncControl, {
                            syncStatus: row.set_producttype_syncstatus,
                            rowData: row,
                            syncHandler: syncProductType,
                            syncPayload: function(data) {
                                return {
                                    pdtypeid: data.set_producttype_id
                                };
                            },
                            syncHandlerOptions: {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            },
                            onSyncSuccess: function() {
                                return props.reDataMst();
                            }
                        })
                    ]
                });
            }
        }
    ];
    useEffect(function() {
        if (filterText && filterText != "" && filterText != null) {
            setFilteredItems(dataPdType.filter(function(item) {
                return item.set_producttype_id !== null && item.set_producttype_id > 0 && (item.set_producttype_code != null && item.set_producttype_code.toUpperCase().includes(filterText.toUpperCase()) || item.set_producttype_name != null && item.set_producttype_name.includes(filterText) || item.set_producttype_nameen != null && item.set_producttype_nameen.includes(filterText) || item.set_producttype_namela != null && item.set_producttype_namela.includes(filterText));
            }));
        } else {
            setFilteredItems(dataPdType.filter(function(item) {
                return item.set_producttype_id !== null && item.set_producttype_id > 0;
            }));
        }
    }, [
        dataPdType,
        filterText
    ]);
    useEffect(function() {
        if (filteredItems && filteredItems.length > 0) {
            filteredItems.map(function(item, index) {
                if (item.set_producttype_id && item.set_producttype_id != "" && item.set_producttype_id > 0) {
                    setExcelData(function(excelData) {
                        return _to_consumable_array(excelData).concat([
                            {
                                producttype_no: index + 1,
                                producttype_code: item.set_producttype_code || "-",
                                producttype_nameTh: item.set_producttype_name || "-",
                                producttype_nameEn: item.set_producttype_nameen || "-",
                                producttype_nameLao: item.set_producttype_namela || "-",
                                status: item.set_producttype_status && item.set_producttype_status == 2 ? "ปิดใช้งาน" : item.set_producttype_status && item.set_producttype_status == 1 ? "เปิดใช้งาน" : "-"
                            }
                        ]);
                    });
                }
            });
        }
    }, [
        filteredItems
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-1 mb-4",
                children: /*#__PURE__*/ _jsxs(CardBody, {
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            className: "align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    lg: 7,
                                    className: "mb-2",
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: excelData,
                                        filename: "pd_type_" + moment().format("YYYYMMDDHHmmss")
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    lg: 5,
                                    children: /*#__PURE__*/ _jsxs(Stack, {
                                        direction: "horizontal",
                                        gap: 2,
                                        children: [
                                            /*#__PURE__*/ _jsx("input", {
                                                type: "text",
                                                className: "form-control form-st-4 form-200 mb-2",
                                                placeholder: "ค้นหา ชื่อประเภท",
                                                onKeyUp: function(e) {
                                                    setFilterText(e.target.value);
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                className: "btn-st-7 px-2 mb-2",
                                                style: {
                                                    minWidth: 160
                                                },
                                                onClick: function() {
                                                    setModal(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            open: true,
                                                            typeData: "createType",
                                                            data: null
                                                        });
                                                    });
                                                    setmodelText("สร้างประเภทสินค้า");
                                                },
                                                variant: "",
                                                children: "เพิ่มประเภทสินค้า"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10,
                            sortAsc: false
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(TypePdModel, {
                    setModal: setModal,
                    modal: modal,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    reData: props.reDataMst
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    reData: props.reDataMst
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
function ProductCateData(_param) {
    var dataPdCate = _param.dataPdCate, setDataPdCate = _param.setDataPdCate, props = _object_without_properties(_param, [
        "dataPdCate",
        "setDataPdCate"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), excelData = _useState[0], setExcelData = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), filteredItems = _useState1[0], setFilteredItems = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), filterText = _useState2[0], setFilterText = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), reloadType = _useState3[0], setReloadType = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), textsuccess = _useState5[0], setTextsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), modelText = _useState6[0], setmodelText = _useState6[1];
    var optionPdType = props.optionPdType && props.optionPdType.length > 0 ? props.optionPdType : [];
    // const idPdType = (props.idPdType && props.idPdType>0)? props.idPdType : 0;
    var _useState7 = _sliced_to_array(useState([]), 2), optionPdTypeSeach = _useState7[0], setOptionPdTypeSeach = _useState7[1];
    var _useState8 = _sliced_to_array(useState("*"), 2), idPdTypeSeach = _useState8[0], setIdPdTypeSeach = _useState8[1];
    var handleViewSubCate = function() {
        var idPdCate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        // if(idPdCate && idPdCate != '' && idPdCate != null && idPdCate >= 0){
        //   props.setIdPdCate(parseInt(idPdCate,10));
        // }
        // else{
        //   props.setIdPdCate(0);
        // }
        props.setNoTab(3);
    };
    var _useState9 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 420,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState9[0], setModal = _useState9[1];
    var _useState10 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState10[0], setModalDel = _useState10[1];
    var columns = [
        {
            name: "ลำดับที่",
            selector: function(row) {
                return row.set_productcategory_no;
            },
            center: "true",
            width: "80px"
        },
        {
            name: "รหัสหมวดหมู่หลัก",
            selector: function(row) {
                var _row_set_productcategory_code;
                return (_row_set_productcategory_code = row.set_productcategory_code) !== null && _row_set_productcategory_code !== void 0 ? _row_set_productcategory_code : "-";
            },
            center: "true",
            width: "150px"
        },
        {
            name: "ชื่อหมวดหมู่หลัก (TH)",
            selector: function(row) {
                var _row_set_productcategory_name;
                return (_row_set_productcategory_name = row.set_productcategory_name) !== null && _row_set_productcategory_name !== void 0 ? _row_set_productcategory_name : "-";
            }
        },
        {
            name: "ชื่อหมวดหมู่หลัก (EN)",
            selector: function(row) {
                var _row_set_productcategory_nameen;
                return (_row_set_productcategory_nameen = row.set_productcategory_nameen) !== null && _row_set_productcategory_nameen !== void 0 ? _row_set_productcategory_nameen : "-";
            }
        },
        {
            name: "ชื่อหมวดหมู่หลัก (LAO)",
            selector: function(row) {
                var _row_set_productcategory_namela;
                return (_row_set_productcategory_namela = row.set_productcategory_namela) !== null && _row_set_productcategory_namela !== void 0 ? _row_set_productcategory_namela : "-";
            }
        },
        {
            name: "ประเภทสินค้า",
            selector: function(row) {
                return row.set_productcategory_typeid;
            },
            //center: "true",
            cell: function(row) {
                var _optionPdType_find;
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.set_productcategory_typeid && row.set_productcategory_typeid > 0 && optionPdType && optionPdType.length > 0 ? (optionPdType === null || optionPdType === void 0 ? void 0 : (_optionPdType_find = optionPdType.find(function(item) {
                        return item.value === row.set_productcategory_typeid;
                    })) === null || _optionPdType_find === void 0 ? void 0 : _optionPdType_find.label) || "-" : "-"
                });
            }
        },
        {
            name: "จำนวนหมวดหมู่ย่อย",
            selector: function(row) {
                return row.set_productcategory_subcate_amount ? parseInt(row.set_productcategory_subcate_amount, 10) : 0;
            },
            center: "true",
            width: "200px"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.set_productcategory_status;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return row.set_productcategory_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: row.set_productcategory_status_text
                }) || row.set_productcategory_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: row.set_productcategory_status_text
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.set_productcategory_id;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center gap-1",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "editCate",
                                        data: {
                                            id: row.set_productcategory_id,
                                            name: row.set_productcategory_name,
                                            nameEn: row.set_productcategory_nameen,
                                            nameLao: row.set_productcategory_namela,
                                            status: row.set_productcategory_status,
                                            typeid: row.set_productcategory_typeid
                                        }
                                    });
                                });
                                setmodelText("แก้ไขหมวดหมู่หลัก");
                            },
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                style: {
                                    color: "#797A7A",
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#E9E9E9",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalDel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "deleteCate",
                                        data: {
                                            id: row.set_productcategory_id,
                                            name: row.set_productcategory_name
                                        }
                                    });
                                });
                                setmodelText("ยืนยันลบหมวดหมู่หลัก");
                            },
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                style: {
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "rgb(255, 227, 227)",
                                    color: "#FF0000",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(DataSyncControl, {
                            syncStatus: row.set_productcategory_syncstatus,
                            rowData: row,
                            syncHandler: syncProductCategory,
                            syncPayload: function(data) {
                                return {
                                    pdcateid: data.set_productcategory_id
                                };
                            },
                            syncHandlerOptions: {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            },
                            onSyncSuccess: function() {
                                return props.reDataMst();
                            }
                        })
                    ]
                });
            }
        }
    ];
    useEffect(function() {
        if (dataPdCate.length > 0) {
            handleSearchItem();
        }
    }, [
        dataPdCate,
        idPdTypeSeach,
        filterText
    ]);
    useEffect(function() {
        if (filteredItems && filteredItems.length > 0) {
            filteredItems.map(function(item, index) {
                if (item.set_productcategory_id && item.set_productcategory_id != "" && item.set_productcategory_id > 0) {
                    setExcelData(function(excelData) {
                        var _optionPdType_find;
                        return _to_consumable_array(excelData).concat([
                            {
                                product_cate_no: index + 1,
                                product_cate_code: item.set_productcategory_code || "-",
                                product_cate_nameTh: item.set_productcategory_name || "-",
                                product_cate_nameEn: item.set_productcategory_nameen || "-",
                                product_cate_nameLao: item.set_productcategory_namela || "-",
                                product_type_name: item.set_productcategory_typeid && item.set_productcategory_typeid > 0 ? (optionPdType === null || optionPdType === void 0 ? void 0 : (_optionPdType_find = optionPdType.find(function(item2) {
                                    return item2.value === item.set_productcategory_typeid;
                                })) === null || _optionPdType_find === void 0 ? void 0 : _optionPdType_find.label) || "-" : "-",
                                product_sub_cate_amount: item.set_productcategory_subcate_amount || 0,
                                status: item.set_productcategory_status_text || "-"
                            }
                        ]);
                    });
                }
            });
        }
    }, [
        filteredItems
    ]);
    useEffect(function() {
        if (optionPdType && optionPdType.length > 0) {
            setOptionPdTypeSeach([
                {
                    value: "*",
                    label: "ทั้งหมด"
                }
            ].concat(_to_consumable_array(optionPdType)));
        }
    }, [
        optionPdType
    ]);
    var handleSearchItem = function() {
        var filtered = dataPdCate.filter(function(item) {
            var _item_set_productcategory_name, _item_set_productcategory_nameen, _item_set_productcategory_namela;
            // กำหนดทุกเงื่อนไขไว้ใน array แล้วใช้ .every() เพื่อตรวจสอบทั้งหมด
            var conditions = [
                {
                    valid: idPdTypeSeach !== null && idPdTypeSeach !== undefined && idPdTypeSeach !== 0 && idPdTypeSeach !== "*",
                    match: item.set_productcategory_typeid === idPdTypeSeach
                },
                {
                    valid: (filterText === null || filterText === void 0 ? void 0 : filterText.trim()) !== "",
                    match: item.set_productcategory_code != null && item.set_productcategory_code.toUpperCase().includes(filterText.toUpperCase()) || ((_item_set_productcategory_name = item.set_productcategory_name) === null || _item_set_productcategory_name === void 0 ? void 0 : _item_set_productcategory_name.toLowerCase().includes(filterText.toLowerCase())) || ((_item_set_productcategory_nameen = item.set_productcategory_nameen) === null || _item_set_productcategory_nameen === void 0 ? void 0 : _item_set_productcategory_nameen.toLowerCase().includes(filterText.toLowerCase())) || ((_item_set_productcategory_namela = item.set_productcategory_namela) === null || _item_set_productcategory_namela === void 0 ? void 0 : _item_set_productcategory_namela.toLowerCase().includes(filterText.toLowerCase()))
                },
                {
                    valid: true,
                    match: item.set_productcategory_id > 0
                }
            ];
            // ตรวจสอบให้ทุกเงื่อนไขที่ valid ผ่าน
            return conditions.every(function(cond) {
                return !cond.valid || cond.match;
            });
        });
        setFilteredItems(filtered);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-1 mb-4",
                children: /*#__PURE__*/ _jsxs(CardBody, {
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            className: "align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    lg: 6,
                                    className: "mb-2",
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: excelData,
                                        filename: "pd_cate_" + moment().format("YYYYMMDDHHmmss")
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    lg: 6,
                                    children: /*#__PURE__*/ _jsxs(Stack, {
                                        direction: "horizontal",
                                        gap: 2,
                                        children: [
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "product_type_seach_id",
                                                onChange: function(e) {
                                                    setIdPdTypeSeach(e === null || e === void 0 ? void 0 : e.value); // e อาจเป็น null ถ้า clear
                                                },
                                                className: "w-100 select-st-1 mb-2",
                                                options: optionPdTypeSeach,
                                                placeholder: "เลือกประเภทสินค้า",
                                                value: optionPdTypeSeach.filter(function(item2) {
                                                    return item2.value === idPdTypeSeach;
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("input", {
                                                type: "text",
                                                className: "form-control form-st-4 form-200 mb-2",
                                                placeholder: "ค้นหา ชื่อหมวดหมู่หลัก",
                                                onKeyUp: function(e) {
                                                    setFilterText(e.target.value);
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                className: "btn-st-7 px-2 mb-2",
                                                style: {
                                                    minWidth: 160
                                                },
                                                onClick: function() {
                                                    setModal(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            open: true,
                                                            typeData: "createCate",
                                                            data: null
                                                        });
                                                    });
                                                    setmodelText("สร้างหมวดหมู่หลัก");
                                                },
                                                variant: "",
                                                children: "เพิ่มหมวดหมู่หลัก"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10,
                            sortAsc: false
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(CatePdModel, {
                    setModal: setModal,
                    modal: modal,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    reData: props.reDataMst,
                    optionPdType: optionPdType
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    reData: props.reDataMst
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
function ProductSubCateData(_param) {
    var dataPdSubCate = _param.dataPdSubCate, setDataPdSubCate = _param.setDataPdSubCate, props = _object_without_properties(_param, [
        "dataPdSubCate",
        "setDataPdSubCate"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), excelData = _useState[0], setExcelData = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), filteredItems = _useState1[0], setFilteredItems = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), filterText = _useState2[0], setFilterText = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), reloadType = _useState3[0], setReloadType = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), textsuccess = _useState5[0], setTextsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), modelText = _useState6[0], setmodelText = _useState6[1];
    var optionPdType = props.optionPdType && props.optionPdType.length > 0 ? props.optionPdType : [];
    var optionPdCate = props.optionPdCate && props.optionPdCate.length > 0 ? props.optionPdCate : [];
    var _useState7 = _sliced_to_array(useState("*"), 2), idPdTypeSeach = _useState7[0], setIdPdTypeSeach = _useState7[1];
    var _useState8 = _sliced_to_array(useState("*"), 2), idPdCateSeach = _useState8[0], setIdPdCateSeach = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), optionPdCateSeach = _useState9[0], setOptionPdCateSeach = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), optionPdTypeSeach = _useState10[0], setOptionPdTypeSeach = _useState10[1];
    var dataPdCate = props.dataPdCate && props.dataPdCate.length > 0 ? props.dataPdCate : [];
    var _useState11 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState11[0], setModal = _useState11[1];
    var _useState12 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState12[0], setModalDel = _useState12[1];
    var columns = [
        {
            name: "ลำดับที่",
            selector: function(row) {
                return row.set_productcategorysub_no;
            },
            center: "true",
            width: "80px"
        },
        {
            name: "รหัสหมวดหมู่ย่อย",
            selector: function(row) {
                var _row_set_productcategorysub_code;
                return (_row_set_productcategorysub_code = row.set_productcategorysub_code) !== null && _row_set_productcategorysub_code !== void 0 ? _row_set_productcategorysub_code : "-";
            },
            center: "true",
            width: "150px"
        },
        {
            name: "ชื่อหมวดหมู่ย่อย (TH)",
            selector: function(row) {
                var _row_set_productcategorysub_name;
                return (_row_set_productcategorysub_name = row.set_productcategorysub_name) !== null && _row_set_productcategorysub_name !== void 0 ? _row_set_productcategorysub_name : "-";
            }
        },
        {
            name: "ชื่อหมวดหมู่ย่อย (EN)",
            selector: function(row) {
                var _row_set_productcategorysub_nameen;
                return (_row_set_productcategorysub_nameen = row.set_productcategorysub_nameen) !== null && _row_set_productcategorysub_nameen !== void 0 ? _row_set_productcategorysub_nameen : "-";
            }
        },
        {
            name: "ชื่อหมวดหมู่ย่อย (LAO)",
            selector: function(row) {
                var _row_set_productcategorysub_namela;
                return (_row_set_productcategorysub_namela = row.set_productcategorysub_namela) !== null && _row_set_productcategorysub_namela !== void 0 ? _row_set_productcategorysub_namela : "-";
            }
        },
        {
            name: "หมวดหมู่หลัก",
            selector: function(row) {
                return row.set_productcategorysub_categoryid;
            },
            //center: "true",
            cell: function(row, index, column, id) {
                var _optionPdCate_find;
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.set_productcategorysub_categoryid && row.set_productcategorysub_categoryid > 0 && optionPdCate && optionPdCate.length > 0 ? (optionPdCate === null || optionPdCate === void 0 ? void 0 : (_optionPdCate_find = optionPdCate.find(function(item) {
                        return item.value === row.set_productcategorysub_categoryid;
                    })) === null || _optionPdCate_find === void 0 ? void 0 : _optionPdCate_find.label) || "-" : "-"
                });
            }
        },
        {
            name: "ประเภทสินค้า",
            selector: function(row) {
                return row.set_productcategorysub_typeid;
            },
            //center: "true",
            cell: function(row, index, column, id) {
                var _optionPdType_find;
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.set_productcategorysub_typeid && row.set_productcategorysub_typeid > 0 && optionPdType && optionPdType.length > 0 ? (optionPdType === null || optionPdType === void 0 ? void 0 : (_optionPdType_find = optionPdType.find(function(item) {
                        return item.value === row.set_productcategorysub_typeid;
                    })) === null || _optionPdType_find === void 0 ? void 0 : _optionPdType_find.label) || "-" : "-"
                });
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.set_productcategorysub_status;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return row.set_productcategorysub_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ใช้งาน"
                }) || row.set_productcategorysub_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่ใช้งาน"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.set_productcategorysub_id;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center gap-1",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "editSubCate",
                                        data: {
                                            id: row.set_productcategorysub_id,
                                            name: row.set_productcategorysub_name,
                                            nameEn: row.set_productcategorysub_nameen,
                                            nameLao: row.set_productcategorysub_namela,
                                            status: row.set_productcategorysub_status,
                                            typeid: row.set_productcategorysub_typeid,
                                            cateid: row.set_productcategorysub_categoryid
                                        }
                                    });
                                });
                                setmodelText("แก้ไขหมวดหมู่ย่อย");
                            },
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                style: {
                                    color: "#797A7A",
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#E9E9E9",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalDel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "deleteSubCate",
                                        data: {
                                            id: row.set_productcategorysub_id,
                                            name: row.set_productcategorysub_name
                                        }
                                    });
                                });
                                setmodelText("ยืนยันลบหมวดหมู่ย่อย");
                            },
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                style: {
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "rgb(255, 227, 227)",
                                    color: "#FF0000",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(DataSyncControl, {
                            syncStatus: row.set_productcategorysub_syncstatus,
                            rowData: row,
                            syncHandler: syncProductSubCategory,
                            syncPayload: function(data) {
                                return {
                                    pdcatesubid: data.set_productcategorysub_id
                                };
                            },
                            syncHandlerOptions: {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            },
                            onSyncSuccess: function() {
                                return props.reDataMst();
                            }
                        })
                    ]
                });
            }
        }
    ];
    useEffect(function() {
        if (dataPdSubCate.length > 0) {
            handleSearchItem();
        }
    }, [
        dataPdSubCate,
        idPdCateSeach,
        filterText
    ]);
    useEffect(function() {
        if (filteredItems && filteredItems.length > 0) {
            filteredItems.map(function(item, index) {
                if (item.set_productcategorysub_id && item.set_productcategorysub_id != "" && item.set_productcategorysub_id > 0) {
                    setExcelData(function(excelData) {
                        var _optionPdCate_find, _optionPdType_find;
                        return _to_consumable_array(excelData).concat([
                            {
                                product_subcate_no: index + 1,
                                product_subcate_code: item.set_productcategorysub_code || "-",
                                product_subcate_nameTh: item.set_productcategorysub_name || "-",
                                product_subcate_nameEn: item.set_productcategorysub_nameen || "-",
                                product_subcate_nameLao: item.set_productcategorysub_namela || "-",
                                product_cate_name: item.set_productcategorysub_categoryid && item.set_productcategorysub_categoryid > 0 ? (optionPdCate === null || optionPdCate === void 0 ? void 0 : (_optionPdCate_find = optionPdCate.find(function(item2) {
                                    return item2.value === item.set_productcategorysub_categoryid;
                                })) === null || _optionPdCate_find === void 0 ? void 0 : _optionPdCate_find.label) || "-" : "-",
                                product_type_name: item.set_productcategorysub_typeid && item.set_productcategorysub_typeid > 0 ? (optionPdType === null || optionPdType === void 0 ? void 0 : (_optionPdType_find = optionPdType.find(function(item2) {
                                    return item2.value === item.set_productcategorysub_typeid;
                                })) === null || _optionPdType_find === void 0 ? void 0 : _optionPdType_find.label) || "-" : "-",
                                status: item.set_productcategorysub_status == 2 ? "ไม่ใช้งาน" : item.set_productcategorysub_status == 1 ? "ใช้งาน" : "-"
                            }
                        ]);
                    });
                }
            });
        }
    }, [
        filteredItems
    ]);
    var prevTypePdId = useRef(idPdTypeSeach);
    useEffect(function() {
        if (prevTypePdId.current !== idPdTypeSeach) {
            if (dataPdCate && dataPdCate.length > 0) {
                var dataPdCateNew = dataPdCate.filter(function(item) {
                    return item.set_productcategory_id !== null && item.set_productcategory_id > 0 && item.set_productcategory_typeid == idPdTypeSeach;
                });
                setOptionPdCateSeach([
                    {
                        value: "*",
                        label: "ทั้งหมด"
                    }
                ].concat(_to_consumable_array(dataPdCateNew.map(function(item2, index) {
                    return {
                        label: item2.set_productcategory_name,
                        value: item2.set_productcategory_id
                    };
                }))));
            }
            if (dataPdSubCate.length > 0) {
                handleSearchItem();
            }
            prevTypePdId.current = idPdTypeSeach;
        }
    }, [
        idPdTypeSeach
    ]);
    useEffect(function() {
        if (optionPdType && optionPdType.length > 0) {
            setOptionPdTypeSeach([
                {
                    value: "*",
                    label: "ทั้งหมด"
                }
            ].concat(_to_consumable_array(optionPdType)));
        }
    }, [
        optionPdType
    ]);
    var handleSearchItem = function() {
        var filtered = dataPdSubCate.filter(function(item) {
            var _item_set_productcategorysub_name, _item_set_productcategorysub_nameen, _item_set_productcategorysub_namela;
            // กำหนดทุกเงื่อนไขไว้ใน array แล้วใช้ .every() เพื่อตรวจสอบทั้งหมด
            var conditions = [
                {
                    valid: idPdTypeSeach !== null && idPdTypeSeach !== undefined && idPdTypeSeach !== 0 && idPdTypeSeach !== "*",
                    match: item.set_productcategorysub_typeid === idPdTypeSeach
                },
                {
                    valid: idPdCateSeach !== null && idPdCateSeach !== undefined && idPdCateSeach !== 0 && idPdCateSeach !== "*",
                    match: item.set_productcategorysub_categoryid === idPdCateSeach
                },
                {
                    valid: (filterText === null || filterText === void 0 ? void 0 : filterText.trim()) !== "",
                    match: item.set_productcategorysub_code != null && item.set_productcategorysub_code.toUpperCase().includes(filterText.toUpperCase()) || ((_item_set_productcategorysub_name = item.set_productcategorysub_name) === null || _item_set_productcategorysub_name === void 0 ? void 0 : _item_set_productcategorysub_name.toLowerCase().includes(filterText.toLowerCase())) || ((_item_set_productcategorysub_nameen = item.set_productcategorysub_nameen) === null || _item_set_productcategorysub_nameen === void 0 ? void 0 : _item_set_productcategorysub_nameen.toLowerCase().includes(filterText.toLowerCase())) || ((_item_set_productcategorysub_namela = item.set_productcategorysub_namela) === null || _item_set_productcategorysub_namela === void 0 ? void 0 : _item_set_productcategorysub_namela.toLowerCase().includes(filterText.toLowerCase()))
                },
                {
                    valid: true,
                    match: item.set_productcategorysub_id > 0
                }
            ];
            // ตรวจสอบให้ทุกเงื่อนไขที่ valid ผ่าน
            return conditions.every(function(cond) {
                return !cond.valid || cond.match;
            });
        });
        setFilteredItems(filtered);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Card, {
                className: "card-st-1 mb-4",
                children: /*#__PURE__*/ _jsxs(CardBody, {
                    children: [
                        /*#__PURE__*/ _jsxs(Row, {
                            className: "align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    lg: 4,
                                    className: "mb-2",
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: excelData,
                                        filename: "pd_sub_cate_" + moment().format("YYYYMMDDHHmmss")
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Col, {
                                    xs: 12,
                                    md: 6,
                                    lg: 8,
                                    children: /*#__PURE__*/ _jsxs(Stack, {
                                        direction: "horizontal",
                                        gap: 2,
                                        children: [
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "product_type_seach_id",
                                                onChange: function(e) {
                                                    setIdPdTypeSeach(e === null || e === void 0 ? void 0 : e.value); // e อาจเป็น null ถ้า clear
                                                },
                                                className: "w-100 select-st-1 mb-2",
                                                options: optionPdTypeSeach,
                                                placeholder: "เลือกประเภทสินค้า",
                                                value: optionPdTypeSeach.filter(function(item2) {
                                                    return item2.value === idPdTypeSeach;
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "product_cate_seach_id",
                                                onChange: function(e) {
                                                    setIdPdCateSeach(e.value);
                                                },
                                                className: "w-100 select-st-1 mb-2",
                                                options: optionPdCateSeach,
                                                placeholder: "เลือกหมวดหมู่หลัก",
                                                value: optionPdCateSeach.filter(function(item2) {
                                                    return item2.value === idPdCateSeach;
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("input", {
                                                type: "text",
                                                className: "form-control form-st-4 form-200 mb-2",
                                                placeholder: "ค้นหา ชื่อหมวดหมู่ย่อย",
                                                style: {
                                                    minHeight: 48
                                                },
                                                onKeyUp: function(e) {
                                                    setFilterText(e.target.value);
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                className: "btn-st-7 px-2 mb-2",
                                                style: {
                                                    minWidth: 160,
                                                    minHeight: 48
                                                },
                                                onClick: function() {
                                                    setModal(function(prev) {
                                                        return _object_spread_props(_object_spread({}, prev), {
                                                            open: true,
                                                            typeData: "createSubCate",
                                                            data: null
                                                        });
                                                    });
                                                    setmodelText("สร้างหมวดหมู่ย่อย");
                                                },
                                                variant: "",
                                                children: "เพิ่มหมวดหมู่ย่อย"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10,
                            sortAsc: false
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(SubCatePdModel, {
                    setModal: setModal,
                    modal: modal,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    reData: props.reDataMst,
                    optionPdType: optionPdType,
                    dataPdCate: dataPdCate
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    reData: props.reDataMst
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
function TypePdModel(_param) {
    var modal = _param.modal, setModal = _param.setModal, setTextsuccess = _param.setTextsuccess, setModalsuccess = _param.setModalsuccess, setIsLoading = _param.setIsLoading, setModalObj = _param.setModalObj, modalObj = _param.modalObj, dataID = _param.dataID, props = _object_without_properties(_param, [
        "modal",
        "setModal",
        "setTextsuccess",
        "setModalsuccess",
        "setIsLoading",
        "setModalObj",
        "modalObj",
        "dataID"
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), name = _useState[0], setName = _useState[1];
    var _useState1 = _sliced_to_array(useState(1), 2), statusTy = _useState1[0], setStatusTy = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), id = _useState2[0], setId = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), textErr = _useState3[0], setTextErr = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), nameEn = _useState4[0], setNameEn = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), textEnErr = _useState5[0], setTextEnErr = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), nameLao = _useState6[0], setNameLao = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), textLaoErr = _useState7[0], setTextLaoErr = _useState7[1];
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var adminId = (adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userId) ? parseInt(adminInfo.userId, 10) : 1;
    var createMstTypeProductReducer = useAppSelector(function(state) {
        return state.createMstTypeProductReducer;
    });
    var updateMstTypeProductReducer = useAppSelector(function(state) {
        return state.updateMstTypeProductReducer;
    });
    useEffect(function() {
        if (!modal.data) {
            setName("");
            setStatusTy(1);
            setId(0);
            setTextErr("");
            setNameEn("");
            setTextEnErr("");
            setNameLao("");
            setTextLaoErr("");
        } else {
            var vul = modal.data;
            setName(vul.name || "");
            setStatusTy(vul.status || 1);
            setId(vul.id || 0);
            setTextErr("");
            setNameEn(vul.nameEn || "");
            setTextEnErr("");
            setNameLao(vul.nameLao || "");
            setTextLaoErr("");
        }
    }, [
        modal.data,
        modal.open
    ]);
    useEffect(function() {
        var isFetching = createMstTypeProductReducer.isFetching || updateMstTypeProductReducer.isFetching;
        setIsLoading(isFetching);
        if (createMstTypeProductReducer.data && !createMstTypeProductReducer.isError) {
            handleSuccess("สร้างประเภทสินค้าสำเร็จ");
            dispatch(clearCreateMstTypeProduct());
        }
        if (updateMstTypeProductReducer.data && !updateMstTypeProductReducer.isError) {
            handleSuccess("แก้ไขประเภทสินค้าสำเร็จ");
            dispatch(clearUpdateMstTypeProduct());
        }
        // ดัก error จาก API แล้วแสดงข้อความ
        if (createMstTypeProductReducer.isError && createMstTypeProductReducer.error) {
            handleError(createMstTypeProductReducer.error);
            dispatch(clearCreateMstTypeProduct());
        }
        if (updateMstTypeProductReducer.isError && updateMstTypeProductReducer.error) {
            handleError(updateMstTypeProductReducer.error);
            dispatch(clearUpdateMstTypeProduct());
        }
    }, [
        createMstTypeProductReducer,
        updateMstTypeProductReducer
    ]);
    var handleSuccess = function(text) {
        setTextsuccess(text);
        setModalsuccess(true);
        props.reData();
        closeModal();
    };
    var handleError = function(errObj) {
        var msg = typeof errObj === "string" ? errObj : errObj.message || "เกิดข้อผิดพลาด กรุณาลองใหม่";
        setTextLaoErr(msg);
    };
    var closeModal = function() {
        setModal(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                open: false
            });
        });
        setName("");
        setStatusTy(1);
        setId(0);
        setTextErr("");
        setNameEn("");
        setTextEnErr("");
        setNameLao("");
        setTextLaoErr("");
    };
    var onClickModel = function() {
        var _ref = _async_to_generator(function() {
            var data, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setTextErr("");
                        setTextEnErr("");
                        setTextLaoErr("");
                        if (!name.trim()) {
                            setTextErr("กรุณากรอกชื่อประเภทสินค้า");
                            return [
                                2
                            ];
                        }
                        data = _object_spread({
                            set_producttype_name: name.trim(),
                            set_producttype_nameen: nameEn.trim(),
                            set_producttype_namela: nameLao.trim(),
                            set_producttype_status: statusTy
                        }, modal.typeData === "editType" ? {
                            set_producttype_id: id,
                            set_producttype_updatebyid: adminId
                        } : {
                            set_producttype_crebyid: adminId
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        if (!(modal.typeData === "createType")) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            dispatch(createMstTypeProduct(data, {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        if (!(modal.typeData === "editType")) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            dispatch(updateMstTypeProduct(data, {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            }))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        err = _state.sent();
                        handleError(err);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickModel() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row gx-xl-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ชื่อประเภทสินค้า (TH)",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(!name ? "is-invalid" : ""),
                                placeholder: "ชื่อประเภทสินค้า (TH)",
                                value: name,
                                onChange: function(e) {
                                    return setName(e.target.value);
                                }
                            }),
                            textErr && /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textErr
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ชื่อประเภทสินค้า (EN)",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(!name ? "is-invalid" : ""),
                                placeholder: "ชื่อประเภทสินค้า (EN)",
                                value: nameEn,
                                onChange: function(e) {
                                    return setNameEn(e.target.value);
                                }
                            }),
                            textEnErr && /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textEnErr
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ชื่อประเภทสินค้า (LAO)",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(!name ? "is-invalid" : ""),
                                placeholder: "ชื่อประเภทสินค้า (LAO)",
                                value: nameLao,
                                onChange: function(e) {
                                    return setNameLao(e.target.value);
                                }
                            }),
                            textLaoErr && /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textLaoErr
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsx(Form.Label, {
                        className: "mb-2 tc-10",
                        children: "สถานะ"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-xl-12 col-md-12",
                    children: [
                        /*#__PURE__*/ _jsx(Form.Check, {
                            inline: true,
                            type: "radio",
                            id: "radio-1",
                            label: "เปิดใช้งาน",
                            checked: statusTy === 1,
                            className: "form-check-st-2 tc-7 mt-0",
                            onChange: function() {
                                return setStatusTy(1);
                            }
                        }),
                        /*#__PURE__*/ _jsx(Form.Check, {
                            inline: true,
                            type: "radio",
                            id: "radio-2",
                            label: "ปิดใช้งาน",
                            checked: statusTy === 2,
                            className: "form-check-st-2 tc-7 mt-0",
                            onChange: function() {
                                return setStatusTy(2);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "horizontal",
                        gap: 3,
                        className: "justify-content-center mt-4",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-6 py-2 px-3",
                                onClick: closeModal,
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn btn-dg w-400",
                                onClick: onClickModel,
                                children: "บันทึก"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function CatePdModel(_param) {
    var modal = _param.modal, setModal = _param.setModal, setTextsuccess = _param.setTextsuccess, setModalsuccess = _param.setModalsuccess, setIsLoading = _param.setIsLoading, setModalObj = _param.setModalObj, modalObj = _param.modalObj, dataID = _param.dataID, props = _object_without_properties(_param, [
        "modal",
        "setModal",
        "setTextsuccess",
        "setModalsuccess",
        "setIsLoading",
        "setModalObj",
        "modalObj",
        "dataID"
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), name = _useState[0], setName = _useState[1];
    var _useState1 = _sliced_to_array(useState(1), 2), statusTy = _useState1[0], setStatusTy = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), id = _useState2[0], setId = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), textErr = _useState3[0], setTextErr = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), textErr2 = _useState4[0], setTextErr2 = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), typePdId = _useState5[0], setTypePdId = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), nameEn = _useState6[0], setNameEn = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), textEnErr = _useState7[0], setTextEnErr = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), nameLao = _useState8[0], setNameLao = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), textLaoErr = _useState9[0], setTextLaoErr = _useState9[1];
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var adminId = (adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userId) ? parseInt(adminInfo.userId, 10) : 1;
    var optionPdType = props.optionPdType && props.optionPdType.length > 0 ? props.optionPdType : [];
    var createMstCateProductReducer = useAppSelector(function(state) {
        return state.createMstCateProductReducer;
    });
    var updateMstCateProductReducer = useAppSelector(function(state) {
        return state.updateMstCateProductReducer;
    });
    useEffect(function() {
        if (!modal.data) {
            setName("");
            setStatusTy(1);
            setId(0);
            setTypePdId(0);
            setTextErr("");
            setTextErr2("");
            setNameEn("");
            setTextEnErr("");
            setNameLao("");
            setTextLaoErr("");
        } else {
            var vul = modal.data;
            setName(vul.name || "");
            setStatusTy(vul.status || 1);
            setId(vul.id || 0);
            setTypePdId(vul.typeid || 0);
            setTextErr("");
            setTextErr2("");
            setNameEn(vul.nameEn || "");
            setTextEnErr("");
            setNameLao(vul.nameLao || "");
            setTextLaoErr("");
        }
    }, [
        modal.data,
        modal.open
    ]);
    useEffect(function() {
        var isFetching = createMstCateProductReducer.isFetching || updateMstCateProductReducer.isFetching;
        setIsLoading(isFetching);
        if (createMstCateProductReducer.data && !createMstCateProductReducer.isError) {
            handleSuccess("สร้างหมวดหมู่หลักสำเร็จ");
            dispatch(clearCreateMstCateProduct());
        }
        if (updateMstCateProductReducer.data && !updateMstCateProductReducer.isError) {
            handleSuccess("แก้ไขหมวดหมู่หลักสำเร็จ");
            dispatch(clearUpdateMstCateProduct());
        }
        // ดัก error จาก API แล้วแสดงข้อความ
        if (createMstCateProductReducer.isError && createMstCateProductReducer.error) {
            handleError(createMstCateProductReducer.error);
            dispatch(createMstCateProductReducer());
        }
        if (updateMstCateProductReducer.isError && updateMstCateProductReducer.error) {
            handleError(updateMstCateProductReducer.error);
            dispatch(clearUpdateMstCateProduct());
        }
    }, [
        createMstCateProductReducer,
        updateMstCateProductReducer
    ]);
    var handleSuccess = function(text) {
        setTextsuccess(text);
        setModalsuccess(true);
        props.reData();
        closeModal();
    };
    var handleError = function(errObj) {
        var msg = typeof errObj === "string" ? errObj : errObj.message || "เกิดข้อผิดพลาด กรุณาลองใหม่";
        setTextErr2(msg);
    };
    var closeModal = function() {
        setModal(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                open: false
            });
        });
        setName("");
        setStatusTy(1);
        setId(0);
        setTypePdId(0);
        setTextErr("");
        setTextErr2("");
        setNameEn("");
        setTextEnErr("");
        setNameLao("");
        setTextLaoErr("");
    };
    var onClickModel = function() {
        var _ref = _async_to_generator(function() {
            var data, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setTextErr("");
                        setTextErr2("");
                        setTextEnErr("");
                        setTextLaoErr("");
                        if (!name.trim()) {
                            setTextErr("กรุณากรอกชื่อหมวดหมู่หลัก");
                            return [
                                2
                            ];
                        } else if (!typePdId || typePdId <= 0) {
                            setTextErr2("กรุณากรุณาเลือกประเภทสินค้า");
                            return [
                                2
                            ];
                        }
                        data = _object_spread({
                            set_productcategory_name: name.trim(),
                            set_productcategory_nameen: nameEn.trim(),
                            set_productcategory_namela: nameLao.trim(),
                            set_productcategory_typeid: typePdId,
                            set_productcategory_status: statusTy
                        }, modal.typeData === "editCate" ? {
                            set_productcategory_id: id,
                            set_productcategory_updatebyid: adminId
                        } : {
                            set_productcategory_crebyid: adminId
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        if (!(modal.typeData === "createCate")) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            dispatch(createMstCateProduct(data, {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        if (!(modal.typeData === "editCate")) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            dispatch(updateMstCateProduct(data, {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            }))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        err = _state.sent();
                        handleError(err);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickModel() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row gx-xl-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ชื่อหมวดหมู่หลัก (TH) ",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(!name ? "is-invalid" : ""),
                                placeholder: "ชื่อหมวดหมู่หลัก (TH)",
                                value: name,
                                onChange: function(e) {
                                    return setName(e.target.value);
                                }
                            }),
                            textErr && /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textErr
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ชื่อหมวดหมู่หลัก (EN) ",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(!nameEn ? "is-invalid" : ""),
                                placeholder: "ชื่อหมวดหมู่หลัก (EN)",
                                value: nameEn,
                                onChange: function(e) {
                                    return setNameEn(e.target.value);
                                }
                            }),
                            textEnErr && /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textEnErr
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ชื่อหมวดหมู่หลัก (LAO) ",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(!nameLao ? "is-invalid" : ""),
                                placeholder: "ชื่อหมวดหมู่หลัก (LAO)",
                                value: nameLao,
                                onChange: function(e) {
                                    return setNameLao(e.target.value);
                                }
                            }),
                            textLaoErr && /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textLaoErr
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ประเภทสินค้า",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Select, {
                                as: "select",
                                name: "set_productcategory_typeid",
                                onChange: function(e) {
                                    setTypePdId(e.value);
                                },
                                className: "w-100 select-st-1",
                                options: optionPdType,
                                placeholder: "เลือกประเภทสินค้า",
                                value: optionPdType.filter(function(item2) {
                                    return item2.value === typePdId;
                                })
                            }),
                            textErr2 && /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textErr2
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsx(Form.Label, {
                        className: "mb-2 tc-10",
                        children: "สถานะ"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-xl-12 col-md-12",
                    children: [
                        /*#__PURE__*/ _jsx(Form.Check, {
                            inline: true,
                            type: "radio",
                            id: "radio-1",
                            label: "เปิดใช้งาน",
                            checked: statusTy === 1,
                            className: "form-check-st-2 tc-7 mt-0",
                            onChange: function() {
                                return setStatusTy(1);
                            }
                        }),
                        /*#__PURE__*/ _jsx(Form.Check, {
                            inline: true,
                            type: "radio",
                            id: "radio-2",
                            label: "ปิดใช้งาน",
                            checked: statusTy === 2,
                            className: "form-check-st-2 tc-7 mt-0",
                            onChange: function() {
                                return setStatusTy(2);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "horizontal",
                        gap: 3,
                        className: "justify-content-center mt-4",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-6 py-2 px-3",
                                onClick: closeModal,
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn btn-dg w-400",
                                onClick: onClickModel,
                                children: "บันทึก"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function SubCatePdModel(_param) {
    var modal = _param.modal, setModal = _param.setModal, setTextsuccess = _param.setTextsuccess, setModalsuccess = _param.setModalsuccess, setIsLoading = _param.setIsLoading, setModalObj = _param.setModalObj, modalObj = _param.modalObj, dataID = _param.dataID, props = _object_without_properties(_param, [
        "modal",
        "setModal",
        "setTextsuccess",
        "setModalsuccess",
        "setIsLoading",
        "setModalObj",
        "modalObj",
        "dataID"
    ]);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), name = _useState[0], setName = _useState[1];
    var _useState1 = _sliced_to_array(useState(1), 2), statusTy = _useState1[0], setStatusTy = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), id = _useState2[0], setId = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), textErr = _useState3[0], setTextErr = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), textErr2 = _useState4[0], setTextErr2 = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), textErr3 = _useState5[0], setTextErr3 = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), typePdId = _useState6[0], setTypePdId = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), catePdId = _useState7[0], setCatePdId = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), nameEn = _useState8[0], setNameEn = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), textEnErr = _useState9[0], setTextEnErr = _useState9[1];
    var _useState10 = _sliced_to_array(useState(""), 2), nameLao = _useState10[0], setNameLao = _useState10[1];
    var _useState11 = _sliced_to_array(useState(""), 2), textLaoErr = _useState11[0], setTextLaoErr = _useState11[1];
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var adminId = (adminInfo === null || adminInfo === void 0 ? void 0 : adminInfo.userId) ? parseInt(adminInfo.userId, 10) : 1;
    var optionPdType = props.optionPdType && props.optionPdType.length > 0 ? props.optionPdType : [];
    var dataPdCate = props.dataPdCate && props.dataPdCate.length > 0 ? props.dataPdCate : [];
    var _useState12 = _sliced_to_array(useState([]), 2), optionPdCate = _useState12[0], setOptionPdCate = _useState12[1];
    var createMstSubCateProductReducer = useAppSelector(function(state) {
        return state.createMstSubCateProductReducer;
    });
    var updateMstSubCateProductReducer = useAppSelector(function(state) {
        return state.updateMstSubCateProductReducer;
    });
    useEffect(function() {
        if (!modal.data) {
            setName("");
            setStatusTy(1);
            setId(0);
            setTypePdId(0);
            setCatePdId(0);
            setTextErr("");
            setTextErr2("");
            setTextErr3("");
            setNameEn("");
            setTextEnErr("");
            setNameLao("");
            setTextLaoErr("");
        } else {
            var vul = modal.data;
            setName(vul.name || "");
            setStatusTy(vul.status || 1);
            setId(vul.id || 0);
            setTypePdId(vul.typeid || 0);
            setCatePdId(vul.cateid || 0);
            setTextErr("");
            setTextErr2("");
            setTextErr3("");
            setNameEn(vul.nameEn || "");
            setTextEnErr("");
            setNameLao(vul.nameLao || "");
            setTextLaoErr("");
        }
    }, [
        modal.data,
        modal.open
    ]);
    useEffect(function() {
        var isFetching = createMstSubCateProductReducer.isFetching || updateMstSubCateProductReducer.isFetching;
        setIsLoading(isFetching);
        if (createMstSubCateProductReducer.data && !createMstSubCateProductReducer.isError) {
            handleSuccess("สร้างหมวดหมู่ย่อยสำเร็จ");
            dispatch(clearCreateMstSubCateProduct());
        }
        if (updateMstSubCateProductReducer.data && !updateMstSubCateProductReducer.isError) {
            handleSuccess("แก้ไขหมวดหมู่ย่อยสำเร็จ");
            dispatch(clearUpdateMstSubCateProduct());
        }
        // ดัก error จาก API แล้วแสดงข้อความ
        if (createMstSubCateProductReducer.isError && createMstSubCateProductReducer.error) {
            handleError(createMstSubCateProductReducer.error);
            dispatch(clearCreateMstSubCateProduct());
        }
        if (updateMstSubCateProductReducer.isError && updateMstSubCateProductReducer.error) {
            handleError(updateMstSubCateProductReducer.error);
            dispatch(clearUpdateMstSubCateProduct());
        }
    }, [
        createMstSubCateProductReducer,
        updateMstSubCateProductReducer
    ]);
    var handleSuccess = function(text) {
        setTextsuccess(text);
        setModalsuccess(true);
        props.reData();
        closeModal();
    };
    var handleError = function(errObj) {
        var msg = typeof errObj === "string" ? errObj : errObj.message || "เกิดข้อผิดพลาด กรุณาลองใหม่";
        setTextErr3(msg);
    };
    var closeModal = function() {
        setModal(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                open: false
            });
        });
        setName("");
        setStatusTy(1);
        setId(0);
        setTypePdId(0);
        setCatePdId(0);
        setTextErr("");
        setTextErr2("");
        setTextErr3("");
        setNameEn("");
        setTextEnErr("");
        setNameLao("");
        setTextLaoErr("");
    };
    var onClickModel = function() {
        var _ref = _async_to_generator(function() {
            var data, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setTextErr("");
                        setTextErr2("");
                        setTextErr3("");
                        setTextEnErr("");
                        setTextLaoErr("");
                        if (!name.trim()) {
                            setTextErr("กรุณากรอกชื่อหมวดหมู่หลัก");
                            return [
                                2
                            ];
                        } else if (!typePdId || typePdId <= 0) {
                            setTextErr2("กรุณากรุณาเลือกประเภทสินค้า");
                            return [
                                2
                            ];
                        } else if (!catePdId || catePdId <= 0) {
                            setTextErr3("กรุณากรุณาเลือกหมวดหมู่หลัก");
                            return [
                                2
                            ];
                        }
                        data = _object_spread({
                            set_productcategorysub_name: name.trim(),
                            set_productcategorysub_nameen: nameEn.trim(),
                            set_productcategorysub_namela: nameLao.trim(),
                            set_productcategorysub_typeid: typePdId,
                            set_productcategorysub_categoryid: catePdId,
                            set_productcategorysub_status: statusTy
                        }, modal.typeData === "editSubCate" ? {
                            set_productcategorysub_id: id,
                            set_productcategorysub_updatebyid: adminId
                        } : {
                            set_productcategorysub_crebyid: adminId
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        if (!(modal.typeData === "createSubCate")) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            dispatch(createMstSubCateProduct(data, {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        if (!(modal.typeData === "editSubCate")) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            dispatch(updateMstSubCateProduct(data, {
                                modalObj: modalObj,
                                setModalObj: setModalObj
                            }))
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        err = _state.sent();
                        handleError(err);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function onClickModel() {
            return _ref.apply(this, arguments);
        };
    }();
    var prevTypePdId = useRef(typePdId);
    useEffect(function() {
        if (prevTypePdId.current !== typePdId) {
            if (dataPdCate && dataPdCate.length > 0) {
                var dataPdCateNew = dataPdCate.filter(function(item) {
                    return item.set_productcategory_id !== null && item.set_productcategory_id > 0 && item.set_productcategory_typeid == typePdId;
                });
                setOptionPdCate(dataPdCateNew.map(function(item2, index) {
                    return {
                        label: item2.set_productcategory_name,
                        value: item2.set_productcategory_id
                    };
                }));
            }
            prevTypePdId.current = typePdId;
        }
    }, [
        typePdId
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row gx-xl-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ชื่อหมวดหมู่ย่อย (TH)",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(!name ? "is-invalid" : ""),
                                placeholder: "ชื่อหมวดหมู่ย่อย",
                                value: name,
                                onChange: function(e) {
                                    return setName(e.target.value);
                                }
                            }),
                            textErr && /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textErr
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ชื่อหมวดหมู่ย่อย (EN)",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(!nameEn ? "is-invalid" : ""),
                                placeholder: "ชื่อหมวดหมู่ย่อย (EN)",
                                value: nameEn,
                                onChange: function(e) {
                                    return setNameEn(e.target.value);
                                }
                            }),
                            textEnErr && /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textEnErr
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ชื่อหมวดหมู่ย่อย (LAO)",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(!nameLao ? "is-invalid" : ""),
                                placeholder: "ชื่อหมวดหมู่ย่อย (LAO)",
                                value: nameLao,
                                onChange: function(e) {
                                    return setNameLao(e.target.value);
                                }
                            }),
                            textLaoErr && /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textLaoErr
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "ประเภทสินค้า",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Select, {
                                as: "select",
                                name: "set_productcategorysub_typeid",
                                onChange: function(e) {
                                    setTypePdId(e.value);
                                },
                                className: "w-100 select-st-1",
                                options: optionPdType,
                                placeholder: "เลือกประเภทสินค้า",
                                value: optionPdType.filter(function(item2) {
                                    return item2.value === typePdId;
                                })
                            }),
                            textErr2 && /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textErr2
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    "หมวดหมู่หลัก",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Select, {
                                as: "select",
                                name: "set_productcategorysub_categoryid",
                                onChange: function(e) {
                                    setCatePdId(e.value);
                                },
                                className: "w-100 select-st-1",
                                options: optionPdCate,
                                placeholder: "เลือกหมวดหมู่หลัก",
                                value: optionPdCate.filter(function(item2) {
                                    return item2.value === catePdId;
                                })
                            }),
                            textErr3 && /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textErr3
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsx(Form.Label, {
                        className: "mb-2 tc-10",
                        children: "สถานะ"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col-xl-12 col-md-12",
                    children: [
                        /*#__PURE__*/ _jsx(Form.Check, {
                            inline: true,
                            type: "radio",
                            id: "radio-1",
                            label: "เปิดใช้งาน",
                            checked: statusTy === 1,
                            className: "form-check-st-2 tc-7 mt-0",
                            onChange: function() {
                                return setStatusTy(1);
                            }
                        }),
                        /*#__PURE__*/ _jsx(Form.Check, {
                            inline: true,
                            type: "radio",
                            id: "radio-2",
                            label: "ปิดใช้งาน",
                            checked: statusTy === 2,
                            className: "form-check-st-2 tc-7 mt-0",
                            onChange: function() {
                                return setStatusTy(2);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "horizontal",
                        gap: 3,
                        className: "justify-content-center mt-4",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-6 py-2 px-3",
                                onClick: closeModal,
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn btn-dg w-400",
                                onClick: onClickModel,
                                children: "บันทึก"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function DelModel(_param) {
    var modal = _param.modal, setModal = _param.setModal, setTextsuccess = _param.setTextsuccess, setModalsuccess = _param.setModalsuccess, setIsLoading = _param.setIsLoading, setModalObj = _param.setModalObj, modalObj = _param.modalObj, dataID = _param.dataID, props = _object_without_properties(_param, [
        "modal",
        "setModal",
        "setTextsuccess",
        "setModalsuccess",
        "setIsLoading",
        "setModalObj",
        "modalObj",
        "dataID"
    ]);
    var _modal_data;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(0), 2), id = _useState[0], setId = _useState[1];
    // reducers สำหรับแต่ละประเภท
    var deleteMstTypeProductReducer = useAppSelector(function(state) {
        return state.deleteMstTypeProductReducer;
    });
    var deleteMstCateProductReducer = useAppSelector(function(state) {
        return state.deleteMstCateProductReducer;
    });
    var deleteMstSubCateProductReducer = useAppSelector(function(state) {
        return state.deleteMstSubCateProductReducer;
    });
    // ตรวจสอบและตั้ง loading state
    useEffect(function() {
        var isLoading = deleteMstTypeProductReducer.isFetching || deleteMstCateProductReducer.isFetching || deleteMstSubCateProductReducer.isFetching;
        setIsLoading(isLoading);
    }, [
        deleteMstTypeProductReducer,
        deleteMstCateProductReducer,
        deleteMstSubCateProductReducer
    ]);
    // ตรวจจับ success
    useEffect(function() {
        var success = false;
        if (modal.typeData === "deleteType" && deleteMstTypeProductReducer.data && !deleteMstTypeProductReducer.isError) {
            dispatch(clearDeleteMstTypeProduct());
            setTextsuccess("ลบประเภทสินค้าสำเร็จ");
            success = true;
        }
        if (modal.typeData === "deleteCate" && deleteMstCateProductReducer.data && !deleteMstCateProductReducer.isError) {
            dispatch(clearDeleteMstCateProduct());
            setTextsuccess("ลบหมวดหมู่หลักสำเร็จ");
            success = true;
        }
        if (modal.typeData === "deleteSubCate" && deleteMstSubCateProductReducer.data && !deleteMstSubCateProductReducer.isError) {
            dispatch(clearDeleteMstSubCateProduct());
            setTextsuccess("ลบหมวดหมู่ย่อยสำเร็จ");
            success = true;
        }
        if (success) {
            var _props_reData;
            setModalsuccess(true);
            (_props_reData = props.reData) === null || _props_reData === void 0 ? void 0 : _props_reData.call(props);
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        deleteMstTypeProductReducer,
        deleteMstCateProductReducer,
        deleteMstSubCateProductReducer
    ]);
    // ตั้งค่า id เมื่อ modal เปิด
    useEffect(function() {
        if (modal.data) {
            setId(modal.data.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    // ฟังก์ชันลบตามประเภท
    var onClickModel = function() {
        var parsedId = parseInt(id, 10);
        if (modal.typeData === "deleteType") {
            dispatch(deleteMstTypeProduct({
                pdtypeid: parsedId
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else if (modal.typeData === "deleteCate") {
            dispatch(deleteMstCateProduct({
                pdcateid: parsedId
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else if (modal.typeData === "deleteSubCate") {
            dispatch(deleteMstSubCateProduct({
                pdcatesubid: parsedId
            }, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3 py-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการลบข้อมูลนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 my-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center mt-5",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex justify-content-center gap-3",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "secondary",
                                className: "btn-st-6",
                                onClick: function() {
                                    return setModal(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            open: false
                                        });
                                    });
                                },
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "danger",
                                className: "btn-dg",
                                onClick: onClickModel,
                                children: "ยืนยัน"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
